import type { AxiosError } from "axios";
import type { IClient, ServerErrorResponse } from "src/types/global";
import { useState, useContext } from "react";
import CreateClientUI from "./CreateClientUI";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { clientService } from "@services/ClientService";
import { GlobalAlertContext } from "@providers/GlobalAlertProvider";
import { formatDate } from "@utils/utils";
const CreateClient = () => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: {
      errors
    }
  } = useForm<IClient>({});
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("Lo sentimos, no se pudo crear este cliente, inténtalo nuevamente");
  const [showError, setShowError] = useState(false);
  const {
    setGlobalAlertMessage,
    setGlobalAlertSeverity,
    showGlobalAlert
  } = useContext(GlobalAlertContext);
  const onSubmit = async (client: IClient) => {
    try {
      setGlobalAlertSeverity("success");
      setGlobalAlertMessage("!Listo! El cliente ha sido creado correctamente");
      setIsLoading(true);
      client.id = 0;
      const res = await clientService.create(client);
      const clientDB = res.data;
      navigate(`/clientes/${res.data.id}`, {
        state: {
          showAlert: true,
          client: {
            ...clientDB,
            creationTime: formatDate(clientDB.creationTime),
            generatedPassword: clientDB.generatedPassword
          }
        }
      });
      showGlobalAlert();
    } catch (e) {
      const error = (e as AxiosError<ServerErrorResponse>);
      if (error.response && error.response.data.error.details === "ClientDuplicateError") {
        setErrorMessage("Ya existe un cliente con esta identificación");
      } else {
        setErrorMessage("Lo sentimos, no se pudo crear este cliente, inténtalo nuevamente");
      }
      setShowError(true);
    } finally {
      setIsLoading(false);
    }
  };
  return <CreateClientUI register={register} onSubmit={handleSubmit(onSubmit)} isLoading={isLoading} errorMessage={errorMessage} showError={showError} errors={errors} closeError={() => setShowError(false)} handleCancelClick={() => navigate("/clientes")} />;
};
export default CreateClient;